import React from 'react';

const CloudUpload = (): JSX.Element => (
  <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.4749 8.72525C26.2581 2.81534 20.478 -0.989724 14.5647 0.226372C9.50132 1.26773 5.86012 5.71171 5.83689 10.8782C5.83689 11.1243 5.84707 11.3764 5.86893 11.6429C2.26674 12.024 -0.344322 15.2514 0.0369742 18.8516C0.390395 22.1885 3.20813 24.7199 6.5656 24.7166H7.33078C7.31329 24.4748 7.29437 24.2345 7.29437 23.9882C7.29437 18.759 11.5359 14.5198 16.7681 14.5198C22.0004 14.5198 26.2418 18.759 26.2418 23.9882C26.2418 24.2344 26.2229 24.4747 26.2054 24.7166H26.9706C31.393 24.7287 34.9879 21.1554 35 16.7355C35.0116 12.4945 31.7108 8.98076 27.4749 8.72525Z"
      fill="#24818F"
      fillOpacity="0.273154"
    />
    <ellipse cx="16.7682" cy="23.9882" rx="8.01623" ry="8.01169" fill="#24818F" />
    <path
      d="M16.7681 29.0866C16.3657 29.0866 16.0394 28.7605 16.0394 28.3583V19.6182C16.0394 19.216 16.3657 18.8899 16.7681 18.8899C17.1706 18.8899 17.4969 19.216 17.4969 19.6182V28.3583C17.4968 28.7605 17.1706 29.0866 16.7681 29.0866Z"
      fill="#FAFAFA"
    />
    <path
      d="M19.6831 23.26C19.4897 23.2603 19.3041 23.1838 19.1672 23.0473L16.7681 20.6481L14.369 23.0473C14.0795 23.3267 13.6182 23.3187 13.3385 23.0294C13.0657 22.7471 13.0657 22.2996 13.3385 22.0174L16.2536 19.104C16.5381 18.8197 16.9994 18.8197 17.284 19.104L20.1991 22.0174C20.4832 22.3022 20.4825 22.7634 20.1974 23.0474C20.0609 23.1835 19.876 23.2599 19.6831 23.26Z"
      fill="#FAFAFA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75192 23.9883C8.75192 28.413 12.3409 32 16.7682 32C21.1934 31.9952 24.7796 28.411 24.7844 23.9883C24.7844 19.5636 21.1954 15.9766 16.7682 15.9766C12.3409 15.9766 8.75192 19.5636 8.75192 23.9883ZM10.2094 23.9882C10.2094 20.368 13.1459 17.4332 16.7682 17.4332C20.3904 17.4332 23.3269 20.368 23.3269 23.9882C23.3269 27.6085 20.3904 30.5433 16.7682 30.5433C13.1459 30.5433 10.2094 27.6085 10.2094 23.9882Z"
      fill="#24818F"
    />
  </svg>
);

export default CloudUpload;
	